import moment from 'moment/moment';

export default (date, format = 'Y-MM-DD', language = 'ja', strict = true) => {
    const args = [date, format, language, strict];
    return new JpMoment(...args);
};

/**
 * JpCarbonのJS実装
 *
 * @see /vendor/enomotodev/jp-carbon/src/JpCarbon/JpCarbon.php
 */
class JpMoment extends moment {
    constructor(date, format = 'Y-MM-DD', language = 'ja', strict = true) {
        const args = [date, format, language, strict];
        const jpMoment = super(...args); // moment

        jpMoment.locale('ja', {
            weekdays: [
                '日曜日',
                '月曜日',
                '火曜日',
                '水曜日',
                '木曜日',
                '金曜日',
                '土曜日',
            ],
            weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
        });

        this._getHoliday = function(params) {
            const [y, m, d, w] = params;

            // 皇室慶弔行事に伴う休日
            if (y === 1959 && m === 4 && d === 10) {
                return '皇太子・明仁親王の結婚の儀';
            } else if (y === 1989 && m === 2 && d === 24) {
                return '昭和天皇の大喪の礼';
            } else if (y === 1990 && m === 11 && d === 12) {
                return '即位の礼正殿の儀';
            } else if (y === 1993 && m === 6 && d === 9) {
                return '皇太子・徳仁親王の結婚の儀';
            } else if (y === 2019 && m === 4 && d === 30) {
                return '国民の休日';
            } else if (y === 2019 && m === 5 && d === 1) {
                return '天皇の即位の日';
            } else if (y === 2019 && m === 5 && d === 2) {
                return '国民の休日';
            } else if (y === 2019 && m === 10 && d === 22) {
                return '即位礼正殿の儀';
            }

            // 東京オリンピック　特別措置法
            if (y === 2020) {
                if (m === 7) {
                    if (d === 23) {
                        return '海の日';
                    } else if (d === 24) {
                        return 'スポーツの日';
                    }
                } else if (m === 8) {
                    if (d === 10) {
                        return '山の日';
                    }
                }
            } else if (y === 2021) {
                if (m === 7) {
                    if (d === 22) {
                        return '海の日';
                    } else if (d === 23) {
                        return 'スポーツの日';
                    }
                } else if (m === 8) {
                    if (d === 8) {
                        return '山の日';
                    }
                }
            }

            // 国民の祝日
            if (m === 1) {
                if (d === 1) {
                    return '元日';
                } else {
                    if (1949 <= y && y <= 1999) {
                        if (d === 15) {
                            return '成人の日';
                        }
                    } else if (2000 <= y) {
                        if (8 <= d && d <= 14 && w === 1) {
                            return '成人の日';
                        }
                    }
                }
            } else if (m === 2) {
                if (1967 <= y) {
                    if (d === 11) {
                        return '建国記念の日';
                    }
                }
                if (2020 <= y && d === 23) {
                    return '天皇誕生日';
                }
            } else if (m === 3) {
                if (19 <= d && d <= 22) {
                    if (d === this.shunBunDay(y)) {
                        return '春分の日';
                    }
                }
            } else if (m === 4) {
                if (d === 29) {
                    if (y <= 1988) {
                        return '天皇誕生日';
                    } else if (y <= 2006) {
                        return 'みどりの日';
                    } else {
                        return '昭和の日';
                    }
                }
            } else if (m === 5) {
                if (d === 3) {
                    return '憲法記念日';
                } else if (d === 4) {
                    if (1988 <= y && y <= 2006 && 1 <= w && w <= 5) {
                        return '国民の休日';
                    } else if (2007 <= y) {
                        return 'みどりの日';
                    }
                } else if (d === 5) {
                    return 'こどもの日';
                }
            } else if (m === 7) {
                if (1996 <= y && y <= 2002) {
                    if (d === 20) {
                        return '海の日';
                    }
                } else if (2003 <= y) {
                    if (15 <= d && d <= 21 && w === 1 && y !== 2020 && y !== 2021) {
                        return '海の日';
                    }
                }
            } else if (m === 8) {
                if (2016 <= y && y !== 2020 && y !== 2021) {
                    if (d === 11) {
                        return '山の日';
                    }
                }
            } else if (m === 9) {
                if (1966 <= y && y <= 2002) {
                    if (d === 15) {
                        return '敬老の日';
                    }
                } else if (2003 <= y) {
                    if (15 <= d && d <= 21 && w === 1) {
                        return '敬老の日';
                    }
                }
                if (2009 <= y && w === 1) {
                    if (21 <= d && d <= 23) {
                        if (d + 1 === this.shuuBunDay(y)) {
                            return '国民の休日';
                        }
                    }
                }
                if (22 <= d && d <= 24) {
                    if (d === this.shuuBunDay(y)) {
                        return '秋分の日';
                    }
                }
            } else if (m === 10) {
                if (1966 <= y && y <= 1999) {
                    if (d === 10) {
                        return '体育の日';
                    }
                } else if (2000 <= y) {
                    if (8 <= d && d <= 14 && w === 1 && y !== 2020 && y !== 2021) {
                        if (2020 <= y) {
                            return 'スポーツの日';
                        }
                        return '体育の日';
                    }
                }
            } else if (m === 11) {
                if (d === 3) {
                    return '文化の日';
                } else if (d === 23) {
                    return '勤労感謝の日';
                }
            } else if (m === 12) {
                if (1989 <= y && y <= 2018 && d === 23) {
                    return '天皇誕生日';
                }
            }
        };

        this.getHoliday = function() {
            const [y, m, d, w] = [
                jpMoment.get('year'),
                jpMoment.get('month') + 1,
                jpMoment.get('date'),
                jpMoment.get('day'),
            ];

            const holiday = this._getHoliday([y, m, d, w]);
            if (holiday) {
                return holiday;
            } else if (w === 1) {
                const yesterday = moment([y, m - 1, d]).subtract(1, 'days'); // 新しい momentオブジェクト
                if (
                    this._getHoliday([
                        yesterday.get('year'),
                        yesterday.get('month') + 1,
                        yesterday.get('date'),
                        yesterday.get('day'),
                    ])
                ) {
                    return '振替休日';
                }
            }
        };

        this.calcDay = function(future, present, past, y) {
            const add = 0.242194 * (y - 1980) - Math.floor((y - 1980) / 4);
            let val = 0;

            switch (true) {
                case 2100 <= y && y <= 2150:
                    val = future + add;
                    break;
                case 1980 <= y:
                    val = present + add;
                    break;
                case 1900 <= y:
                    val = past + add;
                    break;
            }

            // intにcast
            return val >= 0 ? Math.floor(val) : Math.ceil(val);
        };

        this.shunBunDay = function(y) {
            return this.calcDay(21.8519, 20.8431, 20.8357, y);
        };

        this.shuuBunDay = function(y) {
            return this.calcDay(24.2488, 23.2488, 23.2588, y);
        };
    }
}
